<template>
  <!--
    *** 필수항목 ***
    1. .sort-button OPTION에 필수로 "텍스트 컬러 클래스가" 지정되어야함. 컬러는 브랜드 컬러로 기입 됩니다.

    [ 레이아웃 옵션 / default : 없음 ]
    .overflow-x--scroll

    .columns--1/2
    .columns--1/3
    .columns--1/4
    .columns--1/5
    .columns--1/6
    .columns--1/7
    .columns--1/8
    .columns--1/9
    .columns--1/10
    .columns--1/11
    .columns--1/12

    [ 스타일 옵션 / default : 없음 ]
    .style--round
    .style--square
    .style--radius-sm
    .style--radius-md
    .style--radius-lg

    [ 간격 옵션 / default : spacing--sm ]
    .spacing--sm
    .spacing--md
    .spacing--lg

    [ 폰트크기 옵션 / default : font--sm ]
    .font--sm
    .font--md
    .font--lg

    [ 폰트두께 옵션 / default : font--300 ]
    .font--300
    .font--400
    .font--700
    .font--900
  -->
  <div class="sort-button OPTION">
    <div class="sort-button--container clearfix">
      <button
        class="button__list"
        :class="!$route.query.filter ? 'is-selected' : ''"
        @click="filtering('')"
      >전체</button>
      <button
        class="button__list"
        v-for="filter in filters"
        :key="filter"
        :class="$route.query.filter === filter ? 'is-selected' : ''"
        @click="filtering(filter)"
      >{{filter}}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filters: { type: Array, required: true }
  },
  methods: {
    filtering (filter) {
      let { name, query } = this.$router.currentRoute
      query = {
        ...query,
        page: 1,
        filter
      }
      if (!filter) {
        query = null
        // delete query.filter
        // delete query.filterType
      }
      this.$router.push({ name, query })
    }
  },
  components: {
  }
}
</script>

